// Анимация прокрутки
window.AOS = require('aos/dist/aos');

// Отправка формы
require('vgformsender/dist/js/vgformsender');

// VG Spy
//require('vgscrollto');

// Nice Select
require('jquery-nice-select/js/jquery.nice-select');

// Load More
require('vgloadmore/dist/jquery.vegas-loadMore');